import { createAction, createActions } from "redux-actions";

/**
 * Since hideModal if often used in onClick, this will ensure
 * it doesn't pass along a giant event object to redux and
 * anything handling the action
 */
export const hideModal = createAction("HIDE_MODAL", () => null);

export const {
    showModal,

    showInfoToast,
    showWarningToast,
    showErrorToast,
    hideToast,

    uiSetAsyncError,
    uiSetLoading,
    uiSetSubmitting,

    setUserAction,
    setUserLanguage,
    addPosition,

    decrementAlert,
    incrementAlert,
    setCommentCounts,
    numberAlertChange,

    uiPauseReportAHireModal,
    uiSetIsUpdateEmploymentStatusModalClosed,
} = createActions(
    "SHOW_MODAL",

    "SHOW_TOAST",
    "SHOW_INFO_TOAST",
    "SHOW_WARNING_TOAST",
    "SHOW_ERROR_TOAST",
    "HIDE_TOAST",

    "UI_SET_ASYNC_ERROR",
    "UI_SET_LOADING",
    "UI_SET_SUBMITTING",

    "SET_USER_ACTION",
    "SET_USER_LANGUAGE",
    "ADD_POSITION",

    "DECREMENT_ALERT",
    "INCREMENT_ALERT",
    "SET_COMMENT_COUNTS",
    "NUMBER_ALERT_CHANGE",

    "UI_PAUSE_REPORT_A_HIRE_MODAL",
    "UI_SET_IS_UPDATE_EMPLOYMENT_STATUS_MODAL_CLOSED",
);
